import { TranslationObject } from '../../i18n/translation';

const namespace = 'dashboard.admin';

const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Synkronisering av FS-tabeller',
    en: 'Synchronization of FS tables',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Du kan bruke oversikten nedenfor til å manuelt synkronisere data fra forskjellige FS-tabeller inn i Arbeidslivsportalen.',
    en: 'You can use the overview below to manually synchronize data from various FS tables in to Arbeidslivsportalen.',
  },
  syncname: {
    id: `${namespace}.syncname`,
    nb: 'Jobbtype',
    en: 'Job type',
  },
  numberoferrors: {
    id: `${namespace}.numberoferrors`,
    nb: 'Antall feil',
    en: 'Number of errors',
  },
  nestekjoring: {
    id: `${namespace}.nestekjoring`,
    nb: 'Neste synkronisering',
    en: 'Next synchronization',
  },
  sistevellykket: {
    id: `${namespace}.sistevellykket`,
    nb: 'Siste vellykkete synkronisering',
    en: 'Last successful synchronization',
  },
  action: {
    id: `${namespace}.action`,
    nb: 'Handling',
    en: 'Action',
  },
  syncButtonText: {
    id: `${namespace}.syncButtonText`,
    nb: 'Start synkronisering',
    en: 'Start synchronization',
  },
  syncAllButtonText: {
    id: `${namespace}.syncAllButtonText`,
    nb: 'Synkronisér alle tabeller',
    en: 'Synchronize all tables',
  },
  refreshButtonText: {
    id: `${namespace}.refreshButtonText`,
    nb: 'Oppdater tabellinformasjon',
    en: 'Refresh table information',
  },
  syncSuccess: {
    id: `${namespace}.syncSuccess`,
    nb: 'Synkronisering startet',
    en: 'Synchronization started',
  },
};

export default translations;
